import React, { PureComponent } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import './index.css';
import * as icons from 'common/svg/icons';

export class ActionList extends PureComponent {
  render() {
    const { cards, className, theme, style, flexItem } = this.props;
    const CardCSS = cn(
      'actionlist',
      className,
      theme ? theme.map(css => `actionlist--${css}`).join(' ') : ''
    );
    const itemCSS = cn(
      'actionlist__item',
      theme && theme.indexOf('columns') >= 0 ? 'columns' : '',
      { actionlist__flex: flexItem }
    );
    const getIcon = icon => {
      const CustomTag = icons[icon];
      return CustomTag ? <CustomTag className={'actionlist__icon'} /> : null;
    };

    const renderCards = (card, idx) =>
      card.content ? (
        <li key={idx} className={itemCSS}>
          {card.actions && (
            <aside className={'actionlist__actions'}>
              {card.actions.map((action, i) => (
                <a key={`${idx}-${i}`} onClick={action.action}>
                  {getIcon(action.icon)}
                </a>
              ))}
            </aside>
          )}
          {card.content}
        </li>
      ) : null;

    return cards && cards.length ? (
      <ul className={CardCSS} style={style}>
        {cards && cards.map(renderCards)}
      </ul>
    ) : null;
  }
}

ActionList.propTypes = {
  cards: PropTypes.array.isRequired,
  className: PropTypes.string,
  loading: PropTypes.bool,
  style: PropTypes.object,
  theme: PropTypes.array,
  flexItem: PropTypes.bool,
};

export default ActionList;



// WEBPACK FOOTER //
// ./src/common/components/ActionList/index.js